var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title || _vm.description)?_c('div',{staticClass:"loading-wrapper",class:{'error-state': _vm.isErrorState}},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))]),(!_vm.isErrorState)?_c('div',{staticClass:"spinner"},[_vm._v("Loading...")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }